<div class="inner-wrapper" [class.disabled]="disabled">
  <ng-content></ng-content>
</div>
